import { Injectable } from '@angular/core';
import { getStoreScopedKey } from './happy-store-scope.util';

@Injectable({ providedIn: 'root' })
export class HappyStoreStorageService {
  getLocalItem(key: string): string | null {
    return this.read('local', key);
  }

  setLocalItem(key: string, value: string): void {
    this.write('local', key, value);
  }

  removeLocalItem(key: string): void {
    this.remove('local', key);
  }

  getSessionItem(key: string): string | null {
    return this.read('session', key);
  }

  setSessionItem(key: string, value: string): void {
    this.write('session', key, value);
  }

  removeSessionItem(key: string): void {
    this.remove('session', key);
  }

  private read(type: 'local' | 'session', key: string): string | null {
    try {
      return this.getStorage(type)?.getItem(getStoreScopedKey(key)) ?? null;
    } catch {
      return null;
    }
  }

  private write(type: 'local' | 'session', key: string, value: string): void {
    try {
      this.getStorage(type)?.setItem(getStoreScopedKey(key), value);
    } catch {
      // Ignore storage write failures.
    }
  }

  private remove(type: 'local' | 'session', key: string): void {
    try {
      this.getStorage(type)?.removeItem(getStoreScopedKey(key));
    } catch {
      // Ignore storage delete failures.
    }
  }

  private getStorage(type: 'local' | 'session'): Storage | null {
    if (typeof window === 'undefined') {
      return null;
    }

    return type === 'local' ? window.localStorage : window.sessionStorage;
  }
}
